import { Image as ImageIcon } from 'lucide-react'
import { Dropzone } from '@teach/ui'
import { cn } from '@/lib/utils'
import { useMessages } from '@/i18n'
import { messages } from './messages'
import { ARTICLE_GRADIENTS } from '@/features/instructions/components/GradientPicker/presets'
import { getAutoTitleColor } from '@/features/instructions/lib/gradientTextColor'

interface Props {
  title: string
  gradient: string | null
  cardImage: string | null
  titleColor?: string | null
  onMediaClick?: () => void
  className?: string
}

export const Type1Banner = ({
  title,
  gradient,
  cardImage,
  titleColor,
  onMediaClick,
  className,
}: Props) => {
  const m = useMessages(messages)
  const bg = gradient ?? ARTICLE_GRADIENTS[0]
  return (
    <div
      className={cn(
        'w-full rounded-2xl overflow-hidden border border-border shadow-md flex items-center gap-4 px-8 relative',
        className,
      )}
      style={{ background: bg, aspectRatio: '4 / 1' }}
    >
      <h3
        className="flex-1 leading-[1.1] line-clamp-3 text-left"
        style={{
          fontFamily: '"Wix Madefor Display", system-ui, sans-serif',
          fontWeight: 400,
          color: titleColor ?? getAutoTitleColor(bg),
          fontSize: 'clamp(20px, 4.2vw, 56px)',
        }}
      >
        {title || m.untitled}
      </h3>
      <div className="h-[80%] aspect-square shrink-0 flex items-center justify-center">
        {cardImage ? (
          <img
            src={cardImage}
            alt=""
            className="max-h-full max-w-full object-contain drop-shadow-lg cursor-pointer hover:opacity-80 transition-opacity"
            onClick={onMediaClick}
          />
        ) : (
          <Dropzone
            variant="onMedia"
            icon={ImageIcon}
            // Подпись в квадрате шапки не помещалась (на телефоне «Обложка» вылезала
            // под рамку) — хватает значка; название уходит в aria-label.
            title=""
            aria-label={m.cover}
            onClick={onMediaClick}
            disabled={!onMediaClick}
            className="h-full !p-3"
          />
        )}
      </div>
    </div>
  )
}
